import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "configure-reactive-pro-with-rnb--woocommerce-rental--bookings-plugin-"
    }}>{`Configure Reactive Pro with RnB ( WooCommerce Rental & Bookings Plugin )`}</h1>
    <p>{`If you want bookings and rental products in your site then you can use our RnB plugin `}<a parentName="p" {...{
        "href": "https://codecanyon.net/item/rnb-woocommerce-rental-booking-system/14835145?ref=redqteam"
      }}>{`https://codecanyon.net/item/rnb-woocommerce-rental-booking-system/14835145?ref=redqteam`}</a></p>
    <p>{`When your site has bunch of rental properties then you might thinking about searching and filtering facilities for your site. In this case you can relax because we've most amazing Searching & Filtering Plugin (`}<inlineCode parentName="p">{`Reactive Pro`}</inlineCode>{`). which works perfectly with RnB plugin.`}</p>
    <p><strong parentName="p">{`Please check the following configuration to work perfectly RnB plugin with Reactive Pro Plugin.`}</strong></p>
    <p>{`Back-end Configuration :`}</p>
    <pre><code parentName="pre" {...{}}>{`Create a builder post for rental products from Dashboard->Reactive Builder by clicking Add Reactive Builder button
`}</code></pre>
    <p><strong parentName="p">{`Enter a title in title box`}</strong></p>
    <ol>
      <li parentName="ol">{`Select `}<inlineCode parentName="li">{`product`}</inlineCode>{` and `}<inlineCode parentName="li">{`inventory`}</inlineCode>{` post types from `}<inlineCode parentName="li">{`Select post types`}</inlineCode>{` select box`}</li>
      <li parentName="ol">{`Then in Taxonomy Select box you'll find all available taxonomies. From here you can choose all available taxonomies for product and inventory post types. Here is the list of all available taxonomies of inventory and product post types `}<inlineCode parentName="li">{`rnb_categories`}</inlineCode>{`, `}<inlineCode parentName="li">{`resource`}</inlineCode>{`, `}<inlineCode parentName="li">{`person`}</inlineCode>{`, `}<inlineCode parentName="li">{`pickup_location`}</inlineCode>{`, `}<inlineCode parentName="li">{`dropoff_location`}</inlineCode>{`, `}<inlineCode parentName="li">{`attributes`}</inlineCode>{`, `}<inlineCode parentName="li">{`features`}</inlineCode>{`, `}<inlineCode parentName="li">{`deposite`}</inlineCode>{` When you build your search page in front-end then you'll only these taxonomies available here.`}</li>
      <li parentName="ol">{`Like taxonomies you'll find all available meta keys in `}<inlineCode parentName="li">{`Meta Key Select`}</inlineCode>{` box.`}</li>
    </ol>
    <p>{`You can also choose term meta and redirect page from here.`}</p>
    <p><strong parentName="p">{`Please check the following screenshot:`}</strong></p>
    <p><img alt="rnb-reactive.png" src={require("./images/rnb-reactive.png")} /></p>
    <p>{`When you click the update button you'll see a `}<inlineCode parentName="p">{`shortcode`}</inlineCode>{` at top right.`}</p>
    <p><img alt="rnb-reactive-2.png" src={require("./images/rnb-reactive-2.png")} /></p>
    <p>{`Copy it and go to `}<inlineCode parentName="p">{`Dashboard->page`}</inlineCode>{` directory, create a new page and paste this shortcode then click publish button and you're done with back-end settings.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      